"use client";
import { ChatbotBlock } from ".";
import type { ChatbotBlock as ChatbotBlockType } from "../types";
import { BlockId } from "block-system/types";

type Props = {
  projectId: string;
  pageId: string;
  block: ChatbotBlockType;
  blockId: BlockId;
};

export function EmbeddedChatbotBlock(props: Props) {
  return (
    <ChatbotBlock {...props} block={props.block} blockId={props.blockId} />
  );
}
